// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"styles_messageContainer__2hOih","buttonsContainer":"styles_buttonsContainer__3647U","delete":"styles_delete__UoJwY","cancel":"styles_cancel__1Xord"};